//
//
//
//
//
//

import UText from 'cloud-ui.vusion/src/components/u-text.vue';
import UCopy from 'cloud-ui.vusion/src/components/u-copy.vue/index.vue';
export default {
    components: {
        UText,
        UCopy,
    },
    props: {
        value: String,
    },
};
